import React from 'react';
import ReactMarkdown from 'react-markdown';
import remarkGfm from 'remark-gfm';
import rehypeRaw from 'rehype-raw';
import { Box } from '@mui/material';

interface MarkdownRendererProps {
  content: string;
}

const MarkdownRenderer: React.FC<MarkdownRendererProps> = ({ content }) => {
  return (
    <Box
      sx={{
        fontWeight: 400,
        fontSize: { xs: '14px', sm: '16px', md: '18px' },
        lineHeight: '32px',
        letterSpacing: '2%',
        color: '#585858',
        mt: 2,
        whiteSpace: 'normal',
        // Estilos específicos para elementos markdown
        '& h1, & h2, & h3, & h4, & h5, & h6': {
          fontWeight: 700,
          color: '#1976D2',
          marginTop: '24px',
          marginBottom: '16px',
          lineHeight: '1.2',
        },
        '& h1': { fontSize: { xs: '20px', sm: '24px', md: '28px' } },
        '& h2': { fontSize: { xs: '18px', sm: '22px', md: '26px' } },
        '& h3': { fontSize: { xs: '16px', sm: '20px', md: '24px' } },
        '& h4': { fontSize: { xs: '14px', sm: '18px', md: '22px' } },
        '& p': {
          marginBottom: '16px',
          lineHeight: '1.6',
        },
        '& strong': {
          fontWeight: 700,
          color: '#333',
        },
        '& ul, & ol': {
          paddingLeft: '24px',
          marginBottom: '16px',
        },
        '& li': {
          marginBottom: '8px',
          lineHeight: '1.6',
        },
        '& table': {
          width: '100%',
          borderCollapse: 'collapse',
          marginBottom: '24px',
          border: '1px solid #E0E0E0',
        },
        '& th, & td': {
          padding: '12px',
          textAlign: 'left',
          borderBottom: '1px solid #E0E0E0',
          fontSize: { xs: '12px', sm: '14px', md: '16px' },
        },
        '& th': {
          backgroundColor: '#f5f5f5',
          fontWeight: 700,
          color: '#333',
        },
        '& tr:nth-of-type(even)': {
          backgroundColor: '#fafafa',
        },
        '& blockquote': {
          borderLeft: '4px solid #1976D2',
          paddingLeft: '16px',
          marginLeft: 0,
          marginBottom: '16px',
          fontStyle: 'italic',
          color: '#666',
        },
        '& code': {
          backgroundColor: '#f5f5f5',
          padding: '2px 6px',
          borderRadius: '4px',
          fontSize: '0.9em',
          fontFamily: 'monospace',
        },
        '& pre': {
          backgroundColor: '#f5f5f5',
          padding: '16px',
          borderRadius: '8px',
          overflow: 'auto',
          marginBottom: '16px',
        },
        '& pre code': {
          backgroundColor: 'transparent',
          padding: 0,
        },
      }}
    >
      <ReactMarkdown
        remarkPlugins={[remarkGfm]}
        rehypePlugins={[rehypeRaw]}
        components={{
          p: ({ children }) => <p>{children}</p>,
          table: ({ children }) => (
            <table style={{ width: '100%', borderCollapse: 'collapse' }}>
              {children}
            </table>
          ),
        }}
      >
        {content.replace(/\\n/g, '\n')
                .replace(/\n-/g, '<br />-')}
      </ReactMarkdown>
    </Box>
  );
};

export default MarkdownRenderer;